import Ajax from "Utils/ajax";
export const htmlToPdf = (data) => Ajax.post('htmlToPdf',data); 
export const getCourseList = (data) => Ajax.post('LFC/getCourseList',data); 
export const updateCourse = (data) => Ajax.post('LFC/updateCourse',data); 
export const getCourseHeading = (data) => Ajax.post('LFC/getCourseHeading',data);
export const courseCategoryList = (data) => Ajax.post('LFC/courseCategoryList',data);  
export const removeRow = (data) => Ajax.post('LFC/removeCourse',data); 
